/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneListGrid as ResolvedStandaloneListGrid } from 'base/components/standalone/ListGrid';

export const ListGrid: typeof ResolvedStandaloneListGrid = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneListGrid {...props} />
        </ErrorBoundary>
    );
});

export type ListGridProps = PropsFromComponent<typeof ListGrid>;

/** @deprecated Use slot architecture instead */
export const ListGridWith = (extras: DynamicStandaloneExtras): typeof ListGrid => {
    return function ListGrid(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ListGrid');
        return <ResolvedStandaloneListGrid {...mergeProps({ options: { theme } }, props)} />;
    }
}